import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ArticleHeader from '../Article/ArticleHeader/ArticleHeader';
import ArticleBodyParsed from 'common/components/ArticleBodyParsed/ArticleBodyParsed';

import Tags from 'common/components/Tags/Tags';
import ShareLg from 'common/components/ShareLg/ShareLg';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import styles from './NewsArticle.module.scss';

export default class NewsArticleComponent extends Component {
  static propTypes = {
    news: PropTypes.object
  };

  render() {
    const { news } = this.props;
    const { canonicalArticleUrl } = news;
    return (
      <div className={styles.NewsArticle}>
        <InjectMetaTags {...news.seo} canonicalArticle={canonicalArticleUrl} />
        <div>
          <ArticleHeader isLink={false} news={news} />
          <div className={styles.ArticleContent}>
            <ArticleBodyParsed htmlBody={news.textHTML} />
          </div>
          <div className={styles.ArticleFooter}>
            <Tags tags={news.tags} className={styles.ContainerTags} />
            <ShareLg />
            <div className={styles.SeparatingLine} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/News/components/NewsArticle/NewsArticle.js